module.exports = __webpack_public_path__ + "static/img/BN@3x.e9cdde8d.png";